import { WOOTDASH_BASE, wootdashAuthHeaders } from '@/api/wootdash'

// Google Chat como chat interno (plano-google-chat.md): caminho 2 (ponte pelo app "WootDash"), Meu perfil, Admin e o
// popup de conversas (últimas conversas + diretório da ISBET).

export interface GoogleChatMyStatus { bridgeEnabled: boolean; connected: boolean; receiveEnabled: boolean; problem: string | null; syncEnabled?: boolean }
export interface GoogleWorkspaceCheck { key: string; label: string; ok: boolean; problem: string | null }
export interface GoogleWorkspaceTestResult { ok: boolean; checks: GoogleWorkspaceCheck[]; eventsUrl: string; connected: number; receiving: number }
export interface RecentInternalConversation {
  peerAgentId: string; peerName: string; peerAvatarUrl: string | null; lastBody: string; lastAt: string; fromMe: boolean; unread: number
}
export interface DirectoryEntry { email: string; name: string; photoUrl: string | null; agentId: string | null }
export interface DirectorySearchResult { enabled: boolean; people: DirectoryEntry[]; problem: string | null }

const OFFLINE = 'Não foi possível falar com o servidor.'

async function call<T>(token: string, path: string, init: RequestInit, fallback: T): Promise<T> {
  try {
    const res = await fetch(`${WOOTDASH_BASE}${path}`, {
      ...init,
      headers: { ...wootdashAuthHeaders(token), ...(init.body ? { 'Content-Type': 'application/json' } : {}) },
    })
    if (!res.ok) return fallback
    return await res.json()
  } catch {
    return fallback
  }
}

export function getMyGoogleChat(token: string): Promise<GoogleChatMyStatus> {
  return call(token, '/google-chat/minha-conta', {}, { bridgeEnabled: false, connected: false, receiveEnabled: false, problem: OFFLINE })
}

export function setMyGoogleChatReceive(token: string, receive: boolean): Promise<GoogleChatMyStatus> {
  return call(token, '/google-chat/minha-conta', { method: 'PUT', body: JSON.stringify({ receber: receive }) },
    { bridgeEnabled: false, connected: false, receiveEnabled: !receive, problem: OFFLINE })
}

export function testGoogleWorkspace(token: string): Promise<GoogleWorkspaceTestResult> {
  return call(token, '/google-workspace/admin/testar', { method: 'POST' },
    { ok: false, checks: [{ key: 'server', label: 'Servidor', ok: false, problem: OFFLINE }], eventsUrl: '', connected: 0, receiving: 0 })
}

export function listRecentInternalConversations(token: string, limit = 15): Promise<RecentInternalConversation[]> {
  return call(token, `/mensagens-internas/recentes?limite=${limit}`, {}, [])
}

export function searchDirectory(token: string, query: string): Promise<DirectorySearchResult> {
  return call(token, `/mensagens-internas/diretorio?busca=${encodeURIComponent(query)}`, {}, { enabled: false, people: [], problem: null })
}
